export const PRACTICE_AREAS: string[] = [
  "ADMIN", "BANKING", "BANKRUPTCY", "CORPORATE", "EDUCATION", "ENERGY",
  "ENVIRONMENT", "ERISA-C&B", "FAMILY LAW", "GENERAL PRACTICE", "GOVERNMENT",
  "HEALTHCARE", "IMMIGRATION", "INFORMATION TECHNOLOGY", "INSURANCE",
  "INTELLECTUAL PROPERTY", "LABOR & EMPLOYMENT", "LITIGATION", "PERSONAL INJURY",
  "REAL ESTATE", "TAX", "TRANSPORTATION", "TRUSTS & ESTATES", "UNASSIGNED",
];

export const US_STATES: string[] = [
  "Alabama", "Alaska", "Arizona", "Arkansas", "California", "Colorado",
  "Connecticut", "Delaware", "District of Columbia", "Florida", "Georgia",
  "Hawaii", "Idaho", "Illinois", "Indiana", "Iowa", "Kansas", "Kentucky",
  "Louisiana", "Maine", "Maryland", "Massachusetts", "Michigan", "Minnesota",
  "Mississippi", "Missouri", "Montana", "Nebraska", "Nevada", "New Hampshire",
  "New Jersey", "New Mexico", "New York", "North Carolina", "North Dakota",
  "Ohio", "Oklahoma", "Oregon", "Pennsylvania", "Rhode Island", "South Carolina",
  "South Dakota", "Tennessee", "Texas", "Utah", "Vermont", "Virginia",
  "Washington", "West Virginia", "Wisconsin", "Wyoming", "INTERNATIONAL",
];

// Excludes "NO SPECIALTY" (Leopard's blank/any value)
export const SPECIALTIES: string[] = [
  "1ST AMEND", "40 ACT", "ACQUISITIONS", "ADVERTISING", "AFFIRMATIVE ACTION",
  "AGRICULTURE", "ANTI BRIBERY", "ANTI CORRUPTION", "ANTI DUMPING",
  "ANTITRUST & COMPETITION", "APPAREL", "APPELLATE", "ARBITRATION", "ART LAW",
  "ARTIFICIAL INTELLIGENCE", "ASBESTOS", "ASIA", "ASSET BACKED FINANCE",
  "ASSET MANAGEMENT", "AVIATION", "BANKING", "BANKRUPTCY", "BIOCHEMICAL",
  "BIOMEDICAL", "BIOTECHNOLOGY", "BLOCKCHAIN", "BONDS", "BROKER-DEALER",
  "CANNABIS", "CAPITAL MARKETS", "CHAPTER 11", "CHAPTER 15", "CHAPTER 7",
  "CHARITABLE GIVING", "CHEMICAL", "CHEMICAL ENGINEERING", "CHILD SUPPORT & CUSTODY",
  "CIVIL", "CIVIL RIGHTS", "CLASS ACTION", "CLIMATE CHANGE", "COLLECTIONS",
  "COLLECTIVE BARGAINING", "COMMODITIES", "COMMUNICATIONS", "COMPLEX", "COMPLIANCE",
  "COMPUTER", "COMPUTER ENGINEERING", "CONDO ASSOC", "CONSTITUTIONAL", "CONSTRUCTION",
  "CONSUMER FINANCE", "CONTRACTS", "COPYRIGHT", "CORPORATE GOVERNANCE", "COVID-19",
  "CREDITORS RIGHTS", "CRIMINAL", "CROSS-BORDER", "CRYPTOCURRENCY", "CUSTOMS",
  "CYBER SECURITY", "DATA SECURITY", "DEFERRED COMPENSATION", "DERIVATIVES",
  "DISCRIMINATION", "DISTRESSED DEBT", "DIVORCE", "DODD-FRANK", "E-COMMERCE",
  "E-DISCOVERY", "EDUCATION", "EEOC", "ELDER CARE", "ELECTION", "ELECTRIC & GAS",
  "ELECTRICAL", "ELECTRICAL ENGINEERING", "EMERGING GROWTH & STARTUPS",
  "EMERGING MARKETS", "EMINENT DOMAIN", "EMPLOYEE BENEFITS", "ENERGY",
  "ENTERTAINMENT", "ENVIRONMENT", "EQUITY BASED COMP", "ERISA-C&B", "ESOP",
  "EUROPEAN UNION LAW", "EXEC COMPENSATION", "FAMILY LAW", "FCC", "FCPA", "FDA",
  "FINANCE", "FINTECH", "FORECLOSURE", "FRANCHISE", "FRAUD", "FUND FORMATION",
  "GAMING", "GENERAL LIABILITY", "GOVERNMENT", "GOVERNMENT CONTRACTS", "HANDBOOKS",
  "HEALTH & WELFARE PLANS", "HEALTHCARE", "HEDGE FUNDS", "HIPAA",
  "HOMELAND SECURITY", "HOTELS & RESORTS", "HR", "IMMIGRATION", "INCENTIVE PROGRAMS",
  "INDIGENOUS PEOPLE", "INFRASTRUCTURE", "INSURANCE", "INTELLECTUAL PROPERTY",
  "INTERNATIONAL", "INTERNATIONAL ARBITRATION", "INTERNATIONAL TRADE", "INTERNET",
  "INVESTIGATIONS", "INVESTMENT MANAGEMENT", "IPO", "JOINT VENTURE",
  "LABOR & EMPLOYMENT", "LAND USE", "LATIN AMERICA", "LEASING", "LEGISLATIVE",
  "LENDING", "LEVERAGED FINANCE", "LICENSING", "LIFE SCIENCES", "LITIGATION",
  "LOBBYIST", "MALPRACTICE", "MARITIME", "MECHANICAL", "MECHANICAL ENGINEERING",
  "MEDIA", "MEDICAID", "MEDICAL", "MEDICARE", "MERGERS & ACQUISITIONS",
  "MEZZANINE FINANCE", "MORTGAGE BACKED SECURITIES", "MUNICIPAL LIABILITY",
  "NANOTECHNOLOGY", "NON COMPETE", "NON-PROFIT", "OIL & GAS", "OSHA", "OUTSOURCING",
  "PATENT", "PATENT LITIGATION", "PATENT PROSECUTION", "PAYMENT SYSTEMS",
  "PENSION PLANS", "PERSONAL INJURY", "PHARMACEUTICAL", "PREMISES LIABILITY",
  "PRIVACY", "PRIVATE EQUITY", "PROBATE", "PRODUCT LIABILITY", "PROFESSIONAL LIABILITY",
  "PROJECT FINANCE", "PUBLIC FINANCE", "PUBLIC HOUSING", "REAL ESTATE", "REGULATORY",
  "REINSURANCE", "REIT", "RENEWABLE ENERGY", "RESTRUCTURING", "RETIREMENT PLANS",
  "SANCTIONS", "SECURITIES", "SECURITIZATION", "SOFTWARE", "SPECIAL NEEDS", "SPORTS",
  "STRUCTURED FINANCE", "SUBROGATION", "TAX", "TECHNOLOGY", "TECHNOLOGY TRANSACTIONS",
  "TELECOMM", "TORTS", "TRADE", "TRADE SECRETS", "TRADEMARK", "TRANSACTIONAL",
  "TRANSPORTATION", "TRUSTS & ESTATES", "UNFAIR COMPETITION", "UNIONS",
  "VENTURE CAPITAL", "WAGE & HOUR", "WASTE MANAGEMENT", "WATER", "WELFARE PLANS",
  "WHISTLE BLOWER", "WHITE COLLAR CRIME", "WORKERS COMP",
];

export const HONORS: string[] = [
  "ALL HONORS", "CHAMBERS USA 2021", "CHAMBERS USA 2024", "CHAMBERS USA 2025",
  "CIPP", "CLERKSHIP", "CUM LAUDE", "LAW REVIEW", "LEGAL 500", "M.B.A.", "M.D.",
  "MAGNA CUM LAUDE", "ORDER OF THE COIF", "PhD", "RN", "SUMMA CUM LAUDE",
  "TAX LLM", "WITH HONORS",
];

export const ALL_CANDIDATE_TYPES: string[] = [
  "ASSOCIATE", "SENIOR ASSOCIATE", "ASSOCIATE*", "PARTNER", "OF COUNSEL", "SENIOR PARTNER",
];

export interface TierOption { value: number; label: string }

export const FIRM_TIER_OPTIONS: TierOption[] = [
  { value: 50,  label: "Top 50 (Elite)" },
  { value: 100, label: "Top 100" },
  { value: 200, label: "Top 200" },
];

export const SCHOOL_TIER_OPTIONS: TierOption[] = [
  { value: 14,  label: "T-14" },
  { value: 50,  label: "Top 50" },
  { value: 100, label: "Top 100" },
];

export interface LabeledOption { value: string; label: string }

export const KEYWORD_FIELDS: LabeledOption[] = [
  { value: "biography",      label: "Biography" },
  { value: "education_info", label: "Education" },
];

export const KEYWORD_OPERATORS: LabeledOption[] = [
  { value: "contains",       label: "contains" },
  { value: "doesNotContain", label: "does not contain" },
  { value: "startsWith",     label: "starts with" },
  { value: "endsWith",       label: "ends with" },
  { value: "is",             label: "is" },
  { value: "isNot",          label: "is not" },
  { value: "between",        label: "between" },
];
